import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
export const TokenType = new Enum('DO_NOT_USE', 'APPOINTMENT', 'PERSON', 'WEB_MERCHANT', 'MERCHANT_CONTACT', 'LOYALTY_CONTACT', 'CAPITAL_CUSTOMER', 'ANONYMOUS', 'UNIT');
export const Entity = ProtoBaseModel.extend({
  tokenType: attr(TokenType),
  token: attr(String)
});